import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_pt-3 _pb-3 _px-3" }
const _hoisted_2 = { class: "_flex _jc-st _gap-1 _ai-fs" }
const _hoisted_3 = { class: "_flexcol _grow-1 _mw-0" }
const _hoisted_4 = { class: "gfu-hd gfu-hd--h2 _toe" }
const _hoisted_5 = { class: "_mr-1" }
const _hoisted_6 = { class: "_mt-3 _flexwrap _gap-1" }
const _hoisted_7 = { class: "gfu-comment-streams__tags _flexwrap _gap-1" }
const _hoisted_8 = {
  key: 0,
  class: "gfu-comment-streams__paragraph"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_comment_filter_item = _resolveComponent("comment-filter-item")
  const _component_project_comments_streams = _resolveComponent("project-comments-streams")
  const _component_drawer = _resolveComponent("drawer")

  return (_openBlock(), _createBlock(_component_drawer, {
    "is-open": $props.isDrawerOpen,
    "is-filled": true,
    onClose: $options.onDrawerClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Resources.Comments.TagsSectionHeader), 1 /* TEXT */)
          ]),
          _createElementVNode("button", {
            class: "_tc--accent _pa-0 _whs-nw",
            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onDrawerClose && $options.onDrawerClose(...args)), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Resources.Common.ModalCloseButton), 1 /* TEXT */),
            _createVNode(_component_base_icon, { name: "times" })
          ])
        ]),
        _createVNode(_component_project_comments_streams, {
          "comment-thread-id": $props.commentThreadId,
          "current-tag": $props.currentTag,
          onTagDeselected: $options.onTagDeselected,
          onTagSelected: $options.onTagSelected,
          onSearchTags: $options.onSearchTags
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filters, (filter) => {
                return (_openBlock(), _createBlock(_component_comment_filter_item, {
                  key: filter.name,
                  name: filter.name,
                  "is-selected": filter.isSelected,
                  class: _normalizeClass(filter.class),
                  onClick: $event => (filter.fn(filter.value)),
                  "data-qa": `comments-streams:${filter.name}`
                }, null, 8 /* PROPS */, ["name", "is-selected", "class", "onClick", "data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                return (_openBlock(), _createBlock(_component_comment_filter_item, {
                  key: tag.name,
                  name: tag.name,
                  "is-selected": tag.isSelected,
                  class: _normalizeClass(tag.class),
                  onClick: $event => (tag.fn(tag.value)),
                  "data-qa": `comments-streams:${tag.value}`
                }, null, 8 /* PROPS */, ["name", "is-selected", "class", "onClick", "data-qa"]))
              }), 128 /* KEYED_FRAGMENT */)),
              (!$options.tags || !$options.tags.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.Resources.Comments.TagsEmptyStateHeader), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["comment-thread-id", "current-tag", "onTagDeselected", "onTagSelected", "onSearchTags"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open", "onClose"]))
}